module.exports = __webpack_public_path__ + "img/appearance-page.d7373ed.png";